require("./app-bootstrap");
require("./components/components-bootstrap");

import VueX from "vuex";
import emailStore from "./vuex/modules/email";
import assetListStore from "./vuex/modules/assetList";
import DayJsPlugin from "./plugins/dayjs.js";


// Set up plugins
Vue.use(DayJsPlugin, "$dayjs");    // Custom DayJS plugin


// Initialize Vuex store
const store = new VueX.Store({
    modules: {
        email: emailStore,
        assetList: assetListStore
    }
});

var app = new Vue({
    store,   // Vuex store

    mixins: [
        require("./app-root"),
    ],
}).$mount('#app'); // Mount Vue instance
